<template>
  <div
    class="index"
    :style="{ paddingTop: 0.1 + 'rem' }"
    ref="menuMorePaddingTop"
  >
    <!-- <Header ref="header" title="忘记用户名" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
      <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex: 0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">选择用户类型</p>
          </div>
          <div class="stepitem stepitemactive" style="flex: 0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">3</p>
            <p class="stepline3"></p>
            <p class="itemp2">查看用户名</p>
          </div>
          <!-- <div class="stepitem" style="flex: 0.5">
            <p class="itemp1">4</p>

            <p class="itemp2">完成</p>
          </div> -->
        </div>
        <div class="v_showdiv"></div>
        <div class="boxinput">
          <p class="boxTitle">安全验证</p>
          <!-- 手机验证 -->
          <van-form validate-first ref="form1">
            <div class="filed-vertical" v-show="order1">
              <van-radio-group v-model="radio" @change="changRadio">
                <van-radio name="1" icon-size="16" @click="clickRadio">
                  <div class="testtel">
                    <div class="telImg">
                      <img
                        src="@/views/image/userregister/icon_tel.png"
                        alt=""
                      />
                    </div>
                    <div class="teltext">
                      <p class="teltextp1">手机验证</p>
                      <p class="teltextp2">
                        使用账号内已绑定的手机号接收验证码
                      </p>
                    </div>
                  </div>
                </van-radio>
              </van-radio-group>
              <div v-show="radio1">
                <div class="telInput">
                  <div class="lable">账号绑定手机号</div>
                  <van-field
                    v-model="telParm.postPhone"
                      name="postPhone"
                    :rules="checkCodeRulesphone"
                    clearable
                    class="input phone"
                    placeholder="请输入手机号"
                  />
                </div>
                <div class="telInput telInput3">
                  <div class="lable">图形验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="checkCode1"
                      name="checkCode1"
                      clearable
                      :rules="checkCodeRules1"
                      id="verifital_input1"
                      class="input"
                      maxlength="4"
                      placeholder="请输入验证码"
                    ></van-field>

                    <div
                      @click="verificationCode(1)"
                      id="verificationCode1"
                      class="verificationCode"
                    >
                      <div class="codeImg">
                        <img id="code_img1" :src="base64img1" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="telInput telInput3">
                  <div class="lable">手机短信验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="telParm.phoneNo"
                      name="phoneNo"
                      :rules="phoneNoRules"
                      center
                      clearable
                      maxlength="6"
                      placeholder="请输入验证码"
                    >
                    </van-field>
                    <div id="CodeNuber" class="CodeNuber">
                      <van-button
                        size="small"
                        type="info"
                        :disabled="disabled1"
                        @click="getCode(1)"
                        >{{ CodeNuberName1 }}
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="telerr" v-show="isshow1">
                <img
                  src="@/views/image/userregister/icon_er1.png"
                  alt=""
                /><span>账号信息不完整，请选择其他验证方式</span>
              </div>
            </div>
          </van-form>
          <!-- 邮箱验证 -->
          <van-form validate-first ref="form2">
            <div class="filed-vertical" v-show="order2">
              <van-radio-group v-model="radio">
                <van-radio name="2" icon-size="16" @click="clickRadio">
                  <div class="testtel">
                    <div class="telImg">
                      <img
                        src="@/views/image/userregister/icon_emil.png"
                        alt=""
                      />
                    </div>
                    <div class="teltext">
                      <p class="teltextp1">邮箱验证</p>
                      <p class="teltextp2">使用账号内的有效邮箱接收验证码</p>
                    </div>
                    <div class="telInput"></div>
                  </div>
                </van-radio>
              </van-radio-group>
              <div v-show="radio2">
                <div class="telInput">
                  <div class="lable">账号绑定邮箱</div>
                  <van-field
                    name="postEmail"
                     :rules="emailRules"
                     clearable
                    v-model="emailParm.postEmail"
                    class="input"
                    placeholder="请输入邮箱"
                  />
                </div>
                <div class="telInput telInput3">
                  <div class="lable">图形验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      name="checkCode2"
                      :rules="checkCodeRules2"
                      v-model="checkCode2"
                      id="verifital_input"
                      class="input"
                      maxlength="4"
                      clearable
                      placeholder="请输入验证码"
                    ></van-field>

                    <div
                      @click="verificationCode(2)"
                      id="verificationCode2"
                      class="verificationCode"
                    >
                      <div class="codeImg">
                        <img id="code_img2" :src="base64img2" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="telInput telInput3">
                  <div class="lable">邮箱验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      name="emailCodeRules"
                      v-model="emailParm.eamilCheck"
                      :rules="emailCodeRules"
                      center
                      clearable
                      maxlength="6"
                      placeholder="请输入验证码"
                    >
                    </van-field>
                    <div id="CodeNuber" class="CodeNuber">
                      <van-button
                        size="small"
                        type="info"
                        :disabled="disabled2"
                        @click="getCode(2)"
                        >{{ CodeNuberName2 }}
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="telerr" v-show="isshow2">
                <img
                  src="@/views/image/userregister/icon_er1.png"
                  alt=""
                /><span>账号信息不完整，请选择其他验证方式</span>
              </div>
            </div>
          </van-form>
        </div>
      </div>

      <div style="margin: 22px">
        <van-button type="primary" class="btn3" size="large"  @click="blackbtn()">上一步</van-button>
        <van-button
                type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
          @click="fromSubmit()"
          >下一步</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import swSelectDate from "@/views/components/swSelectDate";
import {
  // 引入Dialog弹窗
  Dialog,
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
  Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar
} from "vant";
// 手机号获取验证码
const getVerificationCode = function () {
  this.$http
    .get("/zsdyckserver/mb/user/captcha")
    .then((res) => {
      this.pacClientId1 = res.data.captchaKey;
      this.base64img1 = res.data.img;
      this.checkCode1 = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
// 邮箱获取验证码
const getVerificationemail = function () {
  this.$http
    .get("/zsdyckserver/mb/user/captcha")
    .then((res) => {
      this.pacClientId2 = res.data.captchaKey;
      this.base64img2 = res.data.img;
      this.checkCode2 = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
export default {
  name: "restNameVerify",
  data() {
    return {
      certName: "",
      certpsd: "",
      cerpsed: "",
      certNo: "",
      allVerifyTypeVos: [],
      verifyTypeVos: [],
      order1: true,
      order2: true,
      order3: false,
      radio3: false,
      orginType:'',
      radio2: false,
      radio1: false,
      orginTypeShow: true,
      orginTypeShow1: false,
      emailParm: {
        postEmail: "",
        eamilCheck: "",
      },
      telParm: {
        postPhone: "",
        phoneNo: "",
      },
      account: {
        userName: "",
        startDate: "",
        endDate: "",
        ieFlag: "",
        etpsNm: "",
        socialCreditCode: "",
        realName: "",
        idCard: "",
        mobile: "",
        smsCode: "",
      },
      defaultIndex: 0,

      isSelect: false,
      ischange: false,
      disabled1: false,
      disabled2: false,
      disabled: false,
         disabled3: false,
      showOrginType: false,
      CodeNuberName: "获取验证码",
      CodeNuberName1: "获取验证码",
      CodeNuberName2: "获取验证码",
      CodeNuberName3: "获取验证码",
      base64img1: "",
      base64img2: "",
      base64img3: "",
      pacClientId1: "",
      pacClientId2: "",
      pacClientId3: "",
      downIcon: true,
      headerShow: true,
      downIcon1: true,
      isshow1: false,
      isshow2: false,
      isshow3: false,
      isshowTxt1: false,
      isshowTxt2: false,
      isshowTxt3: false,
      phoneNo: "",
      codeName: "",
      checkCode1: "",
      checkCode2: "",
      checkCode3: "",
      orginTypeArray: [],
      orginTypeData: [
        // { codeName: "进境", codeValue: "I" },
        // { codeName: "出境", codeValue: "E" },
      ],
      checkCodeRulesphone: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "onBlur",
        },

        {
          validator: (value) => {
             var pattern = /^1\d{10}$/
            return pattern.test(value);
          },
          message: "请输入正确的手机号",
          trigger: "onBlur",
        },
      ],
      emailRules: [
        {
          required: true,
          message: "请输入邮箱",
          trigger: "onBlur",
        },

        // {
        //   validator: (value) => {
        //      var pattern = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        //     return pattern.test(value);
        //   },
        //   message: "邮箱格式错误",
        //   trigger: "onBlur",
        // }
      ],
      checkCodeRules1: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      checkCodeRules2: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      checkCodeRules3: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      phoneNoRules: [
        {
          required: true,

          message: "请输入手机验证码",
          trigger: "onBlur",
        },
      ],
      emailCodeRules: [
        {
          required: true,

          message: "请输入验证码",
          trigger: "onBlur",
        },
      ],
      resData: this.$route.query, //获取查询页面传参
      passdType: "password",
      radio: "",
      checkRadioFlag: false,
      statusBar: 0,
      value: "",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getVerificationCode();
  },
  watch: {
    active() {
      if (this.active == 2) {
        //console.log("===============");
        // window.scrollTo({
        //   top: 300,
        // });
      }
    },
    //路由回调刷新
    statusBar() {
      this.headerShow = false;
      this.$nextTick(function () {
        this.statusBar = this.$tool.statusBar(44);
        this.headerShow = true;
      });
    },
  },
  methods: {
    getVerificationemail,
    blackbtn(){
       this.$router.go(-1)
    },
    changmethod() {
      this.ischange = true;
      console.log(1);
    },
    changRadio() {
      this.checkRadioFlag = false;
    },
    clickRadio() {
      if (this.radio == "1") {
        if (this.isshowTxt1) {
          this.isshow1 = true;
          this.radio2 = false;
          this.radio3 = false;
        } else {
           this.getVerificationCode();
          this.radio1 = true;
          this.radio2 = false;
          this.radio3 = false;
          this.isshow2 = false;
          this.isshow3 = false;
        }
      } else if (this.radio == "2") {
        if (this.isshowTxt2) {
          this.isshow2 = true;
          this.radio1 = false;
          this.radio3 = false;
        } else {
          this.getVerificationemail();
          this.isshow1 = false;

          this.isshow3 = false;
          this.radio2 = true;

          this.radio1 = false;
          this.radio3 = false;
        }
      } 
      this.checkRadioFlag = true;
    },
    //手机号验证
    verifymobile() {
      let params = {
        mobile:this.telParm.postPhone,
        verifyCode: this.telParm.phoneNo,
        origin:'5'
      };
      this.$http
        .post("/zsdyckserver/mb/user/prsnByMobile", params)
        .then((res) => {
          if (res.code == "0") {
            this.$router.push({
              path: "/swRestNameEnd",
              query: {
                userName:res.data[0].loginName
              },
            });
          } else {
            this.checkCode1 = "";
            this.telParm.phoneNo = "";
            this.getVerificationCode();
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
    //邮箱验证
    verifyemail() {
      let params = {
          email:this.emailParm.postEmail,
          verifyCode: this.emailParm.eamilCheck,
          origin:'5'
      };
      this.$http
        .post("/zsdyckserver/mb/user/prsnByEmail", params)
        .then((res) => {
          if (res.code == "0") {
              this.$router.push({
                path: "/swRestNameEnd",
                query: {
                  userName:res.data[0].loginName
                },
              });
          } else {
            this.checkCode2 = "";
            this.emailParm.eamilCheck = "";
            this.getVerificationemail();
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
    fromSubmit() {
      if (this.radio1) {
        this.$refs.form1
          .validate()
          .then(() => {
            if (this.isshow1) {
              this.$toast("请选择其他验证方式");
              return false;
            }
            this.verifymobile();
          })
          .catch(() => {});
      } else if (this.radio2) {
        this.$refs.form2
          .validate()
          .then(() => {
            if (this.isshow2) {
              this.$toast("请选择其他验证方式");
              return false;
            }
            this.verifyemail();
          })
          .catch(() => {});
      } else {
        this.$toast("请先选择验证方式");
      }
    },
    getVerificationCode,
    verificationCode: function (val) {
      //  重新点击验证码
      if(val ==1){
      this.getVerificationCode();
      this.checkCode1 = "";
      }else if(val ==2){
        this.getVerificationemail();
        this.checkCode2 = "";
      }
    },
    //获取验证码
    getCode: function (val) {
      if (val == 1) {
        if (this.telParm.postPhone.trim().length == 0) {
          this.$toast("请先填写手机号");
          return;
        }
        if (this.checkCode1.trim().length == 0) {
          this.$toast("请先填写图片验证码");
          return;
        }
        let params = {
          captchaKey: this.pacClientId1,
          captchaValue: this.checkCode1,
          mobile:this.telParm.postPhone,
          origin:'5'
        };

        this.disabled1 = true;
        this.$http
          .post("/zsdyckserver/mb/user/prsnSendMobile", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled1 = false;
                  that.CodeNuberName1 = "重新获取";
                } else {
                  that.disabled1 = true;
                  that.CodeNuberName1 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled1 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      } else if (val == 2) {
        if (this.emailParm.postEmail.trim().length == 0) {
          this.$toast("请先填写邮箱");
          return;
        }
        if (this.checkCode2.trim().length == 0) {
          this.$toast("请先填写图片验证码");
          return;
        }
        let params = {
          captchaKey: this.pacClientId2,
          captchaValue: this.checkCode2,
          email:this.emailParm.postEmail,
          origin:'5'
        };

        this.disabled2 = true;
        this.$http
          .post("/zsdyckserver/mb/user/prsnSendEmail", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled2 = false;
                  that.CodeNuberName2 = "重新获取";
                } else {
                  that.disabled2 = true;
                  that.CodeNuberName2 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled2 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      }
    },
  },
  created() {
    
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == '/resetNameIndex') {
        let that = this
        Dialog.confirm({
          message: "操作未完成，是否退出？",
          theme: "round-button",
        }).then(() => {
          next()
        })
        .catch(() => {
          next(false) 
          Dialog.close();
        });
      }else{
        next()
      }
  },
  components: {
    Header,
    swSelectDate,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Icon.name]: Icon,
    // 注册Dialog弹窗
    [Dialog.name]: Dialog
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
 ::v-deep  .phone .van-field__body {
        padding: 4px 9px 4px 30px !important;
        position: relative;
      }

       ::v-deep .phone .van-field__body::before{
          position: absolute;
          content: "+86";
          left: 4px;
          top: 4px;
          font-size: 14px;
          display: block;
          color: #333;
      }
::v-deep .van-overflow-hidden {
  overflow: visible !important;
  overflow-x: visible !important;
  overflow-y: visible !important;
}
.index{
  min-height: calc(100vh - 44px);
  background: #fff;
}
.windowmain {
  width: 100%;
  padding-bottom: 40px;
  .boxmain {
    width: 100%;
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .boxstep {
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
      padding: 14px 11px 16px 11px;
      .stepitem {
        flex: 1;
        position: relative;
        text-align: center;
        .stepline {
          position: absolute;
          width: 84px;
          height: 1px;
          background: #00599c;
          left: 70px;
          top: 9px;
        }
        .stepline2 {
          position: absolute;
          width: 94px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
          top: 9px;
        }
        .itemp1 {
          width: 17px;
          height: 17px;
          background: #d5d5d5;
          font-size: 11px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          line-height: 18px;
          display: block;
          position: relative;
          margin: 0 auto;
        }
        .itemp2 {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
      .stepitemactive {
        .itemp1 {
          background: #00599c;
        }
        .itemp2 {
          color: #00599c;
        }
      }
    }
  }
  .CodeNuber {
    position: absolute;
    right: 0.106667rem;
    width: 2.4rem;
    height: 0.933333rem;
    top: 7px;
  }
  .van-button--small {
    width: 87px;
    padding: 0px;
    background: #00599c;
    border: 1px solid #00599c;
  }
  .boxinput {
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;

    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      border: 1px solid #ddd;
      box-shadow: 1px 3px 3px 0px #f1f1f1;
      border-radius: 4px;
      padding: 14px 10px;
      .telerr {
        margin-top: 10px;
        height: 24px;
        border: 1px solid #ecd1c2;
        border-radius: 3px;
        font-size: 11px;
        line-height: 24px;
        color: #cc0000;
        background: rgb(246, 233, 226);
        img {
          width: 11px;
          height: 11px;
          margin: 0 10px;
        }
      }
      .testtel {
        width: 100%;
        display: flex;
        .telImg {
          height: 30px;
          width: auto;
          margin: 4px;
          img {
            height: 30px;
          }
        }
        .teltext {
          width: auto;
          margin-left: 16px;
          .teltextp1 {
            font-size: 12px;
            color: #00599c;
          }
          .teltextp2 {
            font-size: 11px;
            color: #999;
          }
        }
      }
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
      .telInput {
        margin-top: 8px;
        margin-left: 9%;
      }
      ::v-deep .telInput1 .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        background: #efefef;
        border-radius: 4px;
        margin-top: 4px;
      }
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }
  ::v-deep .van-cell::after {
    border-bottom: 0px solid #ddd;
  }
  .v_showdiv {
    height: 12px;
    background: #f7f8fa;
  }
  .selectRadio {
    margin-top: 5px;
    width: 100%;
    .van-radio-group {
      width: auto;
      float: right;
    }
  }
  .telInput3 .van-cell {
    width: 64%;
  }
  .verificationCode {
    top: 7px;
  }
  .verificationCode .codeImg {
    width: 88px;
    height: 32px;
  }
  ::v-deep .van-radio__label {
    width: 100%;
  }
  html,
  body {
    overflow: visible;
    -webkit-overflow-scrolling: touch;
    position: relative !important;
  }
  ::v-deep #endDate .van-field--disabled .van-field__body {
    background: #efefef;
    border: 1px solid #ddd;
  }
  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
}
</style>